export default __webpack_public_path__ + "static/media/JAS0170.34I-43273_-25860_0.729ddeb8.jpg";